<template>
  <div>
    <el-radio-group v-model="radioType" class="tab1">
      <el-radio label="出库到机构"></el-radio>
      <el-radio label="出库到个人"></el-radio>
    </el-radio-group>
    <div style="height: 50px"></div>
    <el-form
      v-show="radioType == '出库到个人'"
      :model="rule1"
      :rules="rules1"
      ref="forms1"
      class="demo-ruleForm"
      label-width="100px"
    >
      <el-form-item label="手机号" prop="userId">
        <Individual-customers
          :showOnly="true"
          :handleUserChange="handleUserChange"
        ></Individual-customers>
      </el-form-item>
      <el-form-item label="关联场景" prop="join">
        <el-radio-group v-model="rule1.join">
          <el-radio label="1">仓库</el-radio>
          <el-radio label="2">门店</el-radio>
          <el-radio label="3">运输</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submit1">提交</el-button>
        <el-button @click="block">返回</el-button>
      </el-form-item>
    </el-form>
    <el-form
      v-show="radioType == '出库到机构'"
      :model="rule"
      :rules="rules"
      ref="forms"
      class="demo-ruleForm"
      label-width="100px"
    >
      <el-form-item label="机构名称" prop="insId">
        <el-select v-model="rule.insId" disabled="">
          <el-option value="" label="请选择"></el-option>
          <el-option
            v-for="x in selectList"
            :key="x.id"
            :value="x.id"
            :label="x.name"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="关联场景" prop="join">
        <el-radio-group v-model="rule.join">
          <el-radio label="1">仓库</el-radio>
          <el-radio label="2">门店</el-radio>
          <el-radio label="3">运输</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="submit">提交</el-button>
        <el-button @click="block">返回</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import IndividualCustomers from "../../customer/individualCustomers.vue";

export default {
  components: { IndividualCustomers },

  data() {
    return {
      name: "editins",
      radioType: "出库到机构",
      rule: {
        insId: "",
        devId: "",
        join: "",
      },
      rule1: {
        userId: "",
        join: "",
      },
      userId: "",
      rules: {
        insId: { required: true, message: "请选择机构" },
        join: { required: true, message: "请选择关联场景" },
      },
      rules1: {
        userId: { required: true, message: "请选择用户" },
        join: { required: true, message: "请选择关联场景" },
      },
      selectList: [],
    };
  },
  async created() {
    let selected;
    if (this.$route.params.id) {
      if (this.$store.state.editInfo.length == 0) {
        this.$router.push("/inventory/out");
      } else {
        this.rule.devId = this.$store.state.editInfo.devId;
        selected = this.$store.state.editInfo.institution;
        this.rule.join = (this.$store.state.editInfo.inJoin).toString();
        this.rule1.join =  (this.$store.state.editInfo.inJoin).toString();
      }
    }
    console.log("selected", selected);

    this.$http.post("/manage/institution/listAll").then((data) => {
      this.selectList = data["data"]["data"];
      console.log(this.selectList);
      this.rule.insId = this.selectList.filter((item, i) => {
        console.log(item);
        return item.name == selected;
      })[0].id;
      // console.log(this.selectList.filter((item, i) => {
      //     return item.name == selected;
      // }))
    });
  },
  methods: {
    handleUserChange(props) {
      this.rule1.userId = props.id;
    },
    submit() {
      this.$refs["forms"].validate((valid) => {
        if (valid) {
          let headers = {
            "Content-Type": "multipart/form-data",
          };
          let formData = new FormData();
          if (this.radioType == "出库到机构") {
            formData.append("userType", 0);
            formData.append("targetId", this.rule.insId);
            formData.append("join", this.rule.join);
          } else {
            formData.append("userType", 1);
            formData.append("targetId", this.rule1.userId);
            formData.append("join", this.rule1.join);
          }
          formData.append("devId", this.rule.devId);
          this.$http
            .post("/manage/stock/editOutStock", formData, { headers: headers })
            .then((rs) => {
              if (rs.data.code == 0) {
                this.$message({
                  message: "操作成功",
                  type: "success",
                });
                this.$router.push("/inventory/out");
              } else {
                this.rule.file = "";
                this.$message({
                  message: rs.data.message,
                  type: "error",
                });
              }
            });
        }
      });
    },
    submit1() {
      this.$refs["forms1"].validate((valid) => {
        if (valid) {
          let headers = {
            "Content-Type": "multipart/form-data",
          };
          let formData = new FormData();
          if (this.radioType == "出库到机构") {
            formData.append("userType", 0);
            formData.append("targetId", this.rule.insId);
            formData.append("join", this.rule.join);
          } else {
            formData.append("userType", 1);
            formData.append("targetId", this.rule1.userId);
            formData.append("join", this.rule1.join);
          }
          formData.append("devId", this.rule.devId);
          this.$http
            .post("/manage/stock/editOutStock", formData, { headers: headers })
            .then((rs) => {
              if (rs.data.code == 0) {
                this.$message({
                  message: "操作成功",
                  type: "success",
                });
                this.$router.push("/inventory/out");
              } else {
                this.rule.file = "";
                this.$message({
                  message: rs.data.message,
                  type: "error",
                });
              }
            });
        }
      });
    },
    block() {
      this.$router.push("/inventory/out");
    },
  },
};
</script>
